import {
  ReviewTableOfContents, StickyReviewHeader, ProsConsHeroBlock,
  ResponsibleGamingChecklist, AuthorBylineCard, UpdateDateLine,
} from "@/components/CasinoReviewTemplate";
import { useSEO } from "@/hooks/use-seo";
import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Globe, Calendar, Lock, Users, Trophy, Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo11 from "@assets/logos_extracted/11.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Atraktivní 200 % bonus až do 185 000 Kč + 50 free spinů pro nové hráče",
  "10 % cashback každý týden bez podmínek protočení",
  "Okamžité výběry přes krypto i e-peněženky",
  "Moderní web s tmavým designem a svižným načítáním",
  "Plně funkční mobilní verze bez nutnosti stahování",
];

const cons = [
  "Chybí věrnostní program a další bonusy pro stálé hráče",
  "Slabší herní filtry a absence demo verzí",
  "Licence z Anjouanu má nižší důvěryhodnost než licence EU (např. MGA nebo UKGC)",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>625 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Denní limit výběru:</span><span className={valueClass}>100 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Týdenní limit výběru:</span><span className={valueClass}>250 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Měsíční limit výběru:</span><span className={valueClass}>500 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Počet metod:</span><span className={valueClass}>11 ověřených platebních metod</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>Okamžitě (krypto, e-peněženky)</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Okolo 4 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – vč. RNG certifikovaných her</span></div>
        <div className={rowClass}><span className={labelClass}>Live kasino:</span><span className={valueClass}>250+ stolů – herní show, blackjack, rulety, poker, baccarat</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Demo verze:</span><span className={valueClass}>Nejsou k dispozici</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>Pragmatic Play, One Touch, Live 88</span></div>
        <div className={rowClass}><span className={labelClass}>Turnaje:</span><span className={valueClass}>Ano – od Pragmatic Play Live</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Nonstop, bez víkendů</span></div>
        <div className={rowClass}><span className={labelClass}>Online chat:</span><span className={valueClass}>Ano – odpověď 1–5 minut</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>Ano – odpověď do jednoho dne</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>FAQ sekce:</span><span className={valueClass}>Ano – v patičce webu</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2024</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>SSL šifrování:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Mobilní verze webu – bez stahování</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – plnohodnotná sekce</span></div>
        <div className={rowClass}><span className={labelClass}>Věrnostní program:</span><span className={valueClass}>Není – nahrazuje ho 10% cashback</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Sebevyloučení:", "Ano – od 6 měsíců do 5 let"],
      ["Kontakt pro sebevyloučení:", "Zákaznická podpora"],
      ["Partnerská organizace:", "GambleAware"],
      ["KYC ověření:", "Povinné před výběrem"],
      ["Jeden účet na osobu:", "Ano – výhradně"],
      ["Věková hranice:", "18+"],
    ];
    return <ResponsibleGamingChecklist items={items} />;
  }
  return null;
}

export default function InstantCasinoPage() {
  useSEO({ title: "Instant Casino Recenze 2026 – Okamžité výplaty a 190 000 Kč | HrajBonus", description: "Recenze Instant Casino. Bonus 200 % až 190 000 Kč, okamžité výplaty a 3500+ her. Bez zdlouhavých verifikací. Hodnocení 9.4/10. 18+",
  url: "https://hrajbonus.com/kasina/instant-casino", });

  const [activeTab, setActiveTab] = useState("platby");

  return (
    <>
      <StickyReviewHeader casinoName="Instant Casino" logoSrc={logo11} rating="9.0" ctaUrl={CASINO_URL} />
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo11} alt="Instant Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina Instant Casino</h1>
                    <UpdateDateLine date="15/02/2026" authorName="Mykhailo Romaenko" />
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",        value: "4 000+" },
                    { label: "Minimální vklad",  value: "500 Kč" },
                    { label: "Minimální výběr",  value: "625 Kč" },
                    { label: "Cashback",         value: "10% bez wageru" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>

                <ProsConsHeroBlock pros={pros} cons={cons} />
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 185 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 10% cashback týdně</div>
                  <div className="text-white/50 text-xs mt-1">Cashback bez wageru · Wager bonus 30×</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Instant Casino" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              <ReviewTableOfContents />

              {/* Author opinion */}
              <AuthorBylineCard name="Mykhailo Romaenko" initials="MR" photo={mykhailoPhoto} role="Senior Content Writer" score="9.0" date="15/02/2026">
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Instant Casino, spuštěné v roce 2024, láká sliby okamžitých výběrů výher. Stylový web kasina se nám zdál pro návštěvníky maximálně přívětivý. Domníváme se, že kasino má více plusů, a proto si zaslouží pozornost.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Plusy
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Mínusy
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AuthorBylineCard>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Intro */}
              <div id="prehled" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Přehled kryptokasina Instant Casino
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Instant Casino, spuštěné v roce 2024, láká sliby okamžitých výběrů výher. Stylový web kasina se nám zdál pro návštěvníky maximálně přívětivý.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Návštěvníkům jsou nabízeny automaty, stolní hry, live hry s reálnými krupiéry a plnohodnotná sekce pro sportovní sázky.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Kasino funguje na základě licence z Anjouanu, což zaručuje soulad s tržními standardy. SSL šifrování umožňuje zajistit bezpečnost osobních údajů návštěvníků.
                </p>

                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Instant Casino provozuje svou činnost na základě licence Anjouan. Tato licence zaručuje soulad s mezinárodními tržními standardy, avšak má nižší důvěryhodnost než regulace EU, jako jsou MGA nebo UKGC. Z pohledu českého práva nejde o operátora s národní licencí Ministerstva financí ČR.
                  </p>
                </div>
              </div>

              {/* Klady a zápory */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Klady a zápory Instant Casino</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="font-bold text-green-700 text-sm mb-3">Mezi výhody platformy řadíme:</div>
                    <ul className="space-y-2">
                      {[
                        ["Rozmanitost", "Dostupné jsou automaty, live kasino, sportovní sázky."],
                        ["Cashback", "Všichni hráči dostávají 10% cashback bez nutnosti prosázení."],
                        ["Výplaty", "Finanční transakce na platformě probíhají rychle."],
                        ["Dárek pro nováčky", "Uvítací bonus ohromí i zkušené hráče."],
                      ].map(([title, desc]) => (
                        <li key={title} className="flex items-start gap-2 text-gray-700 text-sm">
                          <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                          <div><span className="font-semibold">{title}:</span> {desc}</div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="font-bold text-red-600 text-sm mb-3">Z nedostatků uvádíme:</div>
                    <ul className="space-y-2">
                      {[
                        ["Bonusy", "Kromě uvítacího bonusu prakticky žádné jiné pobídky nejsou."],
                        ["Sortiment", "V nabídce je okolo 4 tisíc her, což odpovídá menšímu kasinu."],
                        ["Transparentnost", "Řada automatů nemá popis s uvedením RTP."],
                      ].map(([title, desc]) => (
                        <li key={title} className="flex items-start gap-2 text-gray-700 text-sm">
                          <XCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                          <div><span className="font-semibold">{title}:</span> {desc}</div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Who will enjoy it */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Čím zaujme nováčky a zkušené hráče</h2>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Nováčci</div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Nováčkům se bude líbit rychlá registrace a štědrý uvítací bonus. Kromě toho má většina hracích automatů benevolentní minimální sázky – zahrát si můžete doslova za pár haléřů.
                    </p>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Zkušení hráči</div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Zkušení hráči zde najdou stoly pro high-rollery, soutěže od Pragmatic Play a zrychlené výplaty.
                    </p>
                  </div>
                </div>
              </div>

              {/* Registration */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak se zaregistrovat v Instant Casino</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Pro vytvoření nového účtu na platformě otevřete webové stránky kasina Instant. Je to snadné, stačí se držet tohoto jednoduchého postupu:
                </p>
                <div className="space-y-3 mb-4">
                  {[
                    ["Pro začátek:", "Klikněte na žluté tlačítko \u201eSign Up\u201c, které najdete vpravo nahoře."],
                    ["E-mail:", "Vyplňte svou platnou e-mailovou adresu (budete ji potřebovat k potvrzení registrace) a dvakrát zadejte heslo."],
                    ["Telefon:", "Zvolte předvolbu vaší země a napište své mobilní číslo."],
                    ["Osobní údaje:", "Uveďte své jméno, příjmení a datum narození."],
                    ["Adresa:", "Nakonec zadejte svou adresu, město, poštovní směrovací číslo a zemi."],
                  ].map(([step, desc], i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="text-[#003da5] font-black text-sm flex-shrink-0 mt-0.5">{i + 1}.</span>
                      <div>
                        <span className="font-semibold text-gray-900 text-sm">{step}</span>
                        <span className="text-gray-500 text-sm"> {desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-3">
                  <p className="text-amber-700 text-sm">
                    K dokončení registrace už jen stačí zaškrtnout políčko, že souhlasíte s podmínkami a pravidly kasina.
                    Pamatujte, že v kasinu můžete mít jen jeden účet a registrovat se mohou pouze osoby starší 18 let.
                  </p>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Nezapomeňte na nutnost ověření. Tento proces je nezbytný pro výběr výher z kasina. Pro ověření poskytněte zákaznické podpoře skeny/fotografie dokumentů potvrzujících vaši totožnost.
                </p>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Instant Casino: Bonusy a akce</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Pro stimulaci nových návštěvníků a stálých hráčů platforma nabízí uvítací bonus a týdenní cashback ve výši 10 % z prohrané částky.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Co je to uvítací bonus Instant Casino?</h3>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-4">
                  <div className="text-[#003da5] font-black text-xl mb-1">200% bonus k prvnímu vkladu</div>
                  <div className="text-[#c9960f] font-bold text-base mb-1">maximálně 185 000 Kč</div>
                  <div className="text-gray-500 text-xs">Minimální vklad: 500 Kč · Odměna rozdělena na 4 části · Wager: 30× · Platnost: 7 dní</div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">
                  Každý nový uživatel může po registraci na platformě počítat se štědrým dárkem od kasina. Ten spočívá v dalších 200 % (maximálně 185 000 Kč) na první vklad uskutečněný během týdne.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Jak mohu získat uvítací bonus Instant Casino?</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Pro získání uvítacího bonusu od kasina není potřeba žádný bonusový kód – vše je maximálně jednoduché. Dárek od kasina je dostupný při splnění následujících kroků:
                </p>
                <div className="space-y-2 mb-4">
                  {[
                    ["Registrace:", "Navštivte oficiální web Instant Casino a vytvořte si osobní účet."],
                    ["Potvrzení:", "Zaškrtněte políčko s žádostí o uvítací bonus."],
                    ["Vklad na účet:", "Vložte na herní účet v kasinu minimálně 500 Kč."],
                    ["Připsání:", "Získejte dárek pro nováčky."],
                  ].map(([step, desc], i) => (
                    <div key={i} className="flex items-start gap-2.5 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span>
                      <div><span className="font-semibold text-gray-900">{step}</span> <span className="text-gray-600">{desc}</span></div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-xs mb-5 leading-relaxed">
                  Upozornění: Odměna je rozdělena na 4 části. Pro získání dalších 25 % bonusu je nutné prosázet předchozí připsanou část sázkovým požadavkem (wagerem) ×15.
                </p>

                {/* Cashback highlight */}
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-5">
                  <div className="font-bold text-green-800 text-sm mb-2">10% týdenní cashback — BEZ wageringu</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    Věrnostní program chybí. Místo toho je nabízen stálý cashback ve výši 10 %. Výše vrácené částky nezávisí na statusu uživatele ani na jeho aktivitě – každý má právo na vrácení části prohraných peněz. Výplaty probíhají v pondělí. Maximální limit cashbacku je 250 000 Kč týdně.
                  </p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Instant Casino: Bonus bez vkladu</div>
                  <p className="text-gray-600 text-sm">Bonusy bez vkladu na platformě nejsou nabízeny.</p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Vyžaduje Instant Casino bonusové kódy?</div>
                  <p className="text-gray-600 text-sm">
                    Bonusové kódy se používají pro jednorázové akční nabídky. Najít je můžete na webu kasina, v newsletteru nebo na recenzních portálech.
                  </p>
                </div>
              </div>

              {/* UX / Design */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Grafika a uživatelský zážitek</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Při návštěvě platformy okamžitě zaujme stylové černé pozadí s všudypřítomnými červenými prvky. Web vypadá skvěle a funguje jako hodinky. Všechny hry se načítají rychle a běží bez problémů. Rozhraní je vytvořeno maximálně jednoduše a pohodlně. Snadno se v něm zorientuje i nezkušený návštěvník.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Pohodlná navigace na webu</div>
                  <ul className="space-y-1.5">
                    {[
                      "Nahoře se nachází posuvný banner propagující aktuální akce.",
                      "Hlavní část stránky zabírá stručný přehled dostupných her.",
                      "Zde můžete najít hry podle kategorií (nové, populární atd.) a seznam poskytovatelů.",
                      "Patička je tradičně vyhrazena pro užitečné informace.",
                      "Pohodlné vyskakovací menu se nachází v levé části stránky – jsou zde odkazy na kasino, live kasino, sport, akce a FAQ.",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                        <CheckCircle className="w-3.5 h-3.5 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Games */}
              <div id="hry" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jaké hry nabízí Instant Casino?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Sortiment kasina není příliš velký, ale hry v něm jsou kvalitně vybrány.
                </p>
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee] mb-5">
                  <table className="w-full text-sm">
                    <tbody>
                      {[
                        ["Počet her", "Okolo 4 tisíc titulů – úroveň průměrného kasina."],
                        ["Filtry", "Hry seskupeny do tematických sekcí (nové, populární atd.). K dispozici je vyhledávání podle názvu a poskytovatele."],
                        ["Demo hry", "Bezplatné verze automatů nejsou k dispozici."],
                        ["Stolní hry", "Zastoupeny jsou všechny hlavní druhy stolní zábavy."],
                        ["RNG certifikace", "Všechny hrací automaty fungují na principu generátoru náhodných čísel (RNG) a mají příslušné certifikáty."],
                      ].map(([param, desc], i) => (
                        <tr key={i} className={`border-t border-[#eef1f7] ${i === 0 ? "border-t-0" : ""}`}>
                          <td className="px-4 py-2.5 font-semibold text-gray-700 text-xs w-1/3">{param}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{desc}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Hry v kasinu v reálném čase</div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    V sekci live kasina jsou prezentovány populární hry s reálnými krupiéry. Nabídka se skládá z her různých typů:
                  </p>
                  <ul className="space-y-1.5">
                    {[
                      "Sortiment: Nabízeno je více než 250 stolů různých typů: herní show, blackjack, rulety, poker, baccarat.",
                      "Poskytovatelé: Live hry v Instant Casino dodávají populární vývojáři jako Pragmatic Play, One Touch, Live 88.",
                      "Jazyk komunikace: Dealeři v live hrách mluví anglicky. Komunikace je okamžitá, bez zpoždění.",
                      "Pravidelně se konají turnaje od Pragmatic Play Live s možností výhry velkých peněžních částek a free spinů.",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                        <CheckCircle className="w-3.5 h-3.5 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Mobile */}
              <div id="mobilni" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hrajte mobilní verzi na Instant Casino</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Sice nenajdete samostatnou mobilní aplikaci, ale nemusíte mít obavy! Ke všem službám kasina se snadno dostanete ze svého chytrého telefonu přes mobilní verzi webu. Ta se bez problémů otevře v prohlížeči jakéhokoliv zařízení, ať už máte Android nebo iOS.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  I když mnozí hráči možná vyhlížejí stažitelnou aplikaci, i současná mobilní verze nabízí opravdu kvalitní herní zážitek. Rozhraní se skvěle přizpůsobí jakékoliv velikosti obrazovky a vše pohodlně ovládáte dotykem.
                </p>
              </div>

              {/* Payments */}
              <div id="platby-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jaké platební metody nabízí Instant Casino?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Vklad a výběr výher je nabízen pouze prostřednictvím ověřených a spolehlivých metod. Pro vklad/výběr lze použít kteroukoli z 11 dostupných metod. Podrobnější informace jsou k dispozici v sekci \u201ePokladna\u201c osobního kabinetu.
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
                  {[
                    { label: "Minimální vklad",   value: "500 Kč" },
                    { label: "Minimální výběr",   value: "625 Kč" },
                    { label: "Denní limit",        value: "100 000 Kč" },
                    { label: "Týdenní limit",      value: "250 000 Kč" },
                    { label: "Měsíční limit",      value: "500 000 Kč" },
                    { label: "Max. cashback",      value: "250 000 Kč/týden" },
                    { label: "Rychlost výplat",    value: "Ihned (krypto)" },
                    { label: "Poplatky",           value: "Možné při konverzi měn" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-900 font-bold text-xs leading-tight">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-3">Jak vložit peníze</div>
                    <ol className="space-y-1.5 text-gray-600 text-xs list-none">
                      {[
                        "Přihlášení: Nejprve se přihlaste do svého účtu na webu Instant Casino.",
                        "K pokladně: Přejděte do sekce \u201ePokladna\u201c a zvolte možnost \u201eDeposit\u201c (Vklad).",
                        "Vyplnění údajů: Zvolte si platební metodu a vyplňte potřebné údaje ve formuláři.",
                      ].map((step, i) => (
                        <li key={i} className="flex items-start gap-1.5">
                          <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                        </li>
                      ))}
                    </ol>
                    <p className="text-gray-400 text-xs mt-2">Prostředky jsou obvykle připsány na účet ihned po potvrzení platby.</p>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-3">Jak vybrat peníze</div>
                    <ol className="space-y-1.5 text-gray-600 text-xs list-none">
                      {[
                        "Přihlášení: Přihlaste se ke svému účtu na stránkách Instant Casino.",
                        "K pokladně pro výběr: Vstupte do sekce \u201ePokladna\u201c a klikněte na \u201eWithdraw\u201c (Výběr).",
                        "Vyplnění formuláře: Vyberte způsob výběru a vyplňte formulář.",
                      ].map((step, i) => (
                        <li key={i} className="flex items-start gap-1.5">
                          <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                        </li>
                      ))}
                    </ol>
                    <p className="text-gray-400 text-xs mt-2">Výběr podávejte metodou, která byla použita pro vklad. Na účtu nesmí být aktivní bonusy – všechny odměny je třeba prosázet.</p>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div id="podpora-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Instant Casino: Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  V Instant Casino je k dispozici několik variant spojení se zákaznickou podporou: online chat a e-mail. V případě dotazů se doporučuje nejprve prostudovat sekci FAQ (nachází se v patičce). Podpora funguje nonstop bez víkendů.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Online chat</div>
                      <div className="text-green-600 text-xs">Odpověď do 1–5 minut</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">Odpověď do jednoho dne</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-[#f3f6fb] border border-[#dde4ee] rounded-xl">
                    <Clock className="w-5 h-5 text-[#003da5] mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Dostupnost</div>
                      <div className="text-[#003da5] text-xs">Nonstop, bez víkendů</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Safety */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Instant Casino: Bezpečnost a transparentnost</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Pověst Instant Casino se i přes krátkou dobu existence platformy a absenci jakýchkoli ocenění vyvinula celkem dobře. Platforma funguje na základě oficiální licence z Anjouanu a spolehlivě chrání informace hráčů pomocí kryptografických protokolů SSL.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Seznámit se s podmínkami kasina lze v patičce webu. Zde jsou uvedeny všechny potřebné informace pro návštěvníky, včetně sekce FAQ.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Licence Anjouan – oficiální mezinárodní licence",
                    "SSL šifrování kryptografickými protokoly",
                    "KYC ověření před výběrem výher",
                    "Jeden účet na osobu (min. věk 18+)",
                    "Sebevyloučení na 0,5–5 let (přes podporu)",
                    "Partnerství s GambleAware",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Responsible gaming */}
              <div id="zodpovedne-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hrajte zodpovědně v Instant Casino</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Politika zodpovědného hraní je základním kamenem fungování Instant Casino. Je jí věnována samostatná sekce v patičce hlavní stránky webu. Zde se také nacházejí odkazy na partnerskou organizaci Gambleaware.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Pro sebevyloučení na dobu od 0,5 do 5 let se obraťte na zákaznickou podporu.
                </p>
              </div>

              {/* Summary */}
              <div id="verdikt" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Závěr</h2>
                <p className="text-gray-600 leading-relaxed">
                  Instant Casino působí na trhu přibližně rok. Jedná se o menší kasino – nabízí jen okolo 4 tisíc hazardních her. Zároveň však disponuje plnohodnotnou sekcí pro sportovní sázky. Mezi další plusy patří rychlost výběru výher a přehledný web. Celkově platforma mezi konkurencí příliš nevybočuje.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full bg-[#003da5] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">MR</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo11} alt="Logo Instant Casino" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Instant Casino</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 185 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 10% cashback týdně (0× wager)</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,   label: "Rok",             value: "2024" },
                      { icon: Lock,       label: "Licence",         value: "Anjouan" },
                      { icon: Gamepad2,   label: "Počet her",       value: "4 000+" },
                      { icon: CreditCard, label: "Min. vklad",      value: "500 Kč" },
                      { icon: Zap,        label: "Rychlost výplat", value: "Ihned (krypto/e-peněženky)" },
                      { icon: Trophy,     label: "Cashback",        value: "10% týdně (bez wageru)" },
                      { icon: Clock,      label: "Podpora",         value: "Chat (1–5 min), e-mail" },
                      { icon: Users,      label: "Live stoly",      value: "250+" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="instant-casino" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/fastslots" className="text-[#003da5] hover:underline" data-testid="review-link-fast-slots">Fast Slots</a>
              {" · "}
              <a href="/kasina/golden-panda" className="text-[#003da5] hover:underline" data-testid="review-link-golden-panda">Golden Panda</a>
              {" · "}
              <a href="/kasina/onlyspins" className="text-[#003da5] hover:underline" data-testid="review-link-onlyspins">OnlySpins</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
